<template>
  <Loader v-if="loading" />
  <div class="credit-invoice">
    <div class="header-section">
      <h2 class="page-title">Report Mensile dei caricamenti firmati</h2>
      <p class="subtitle">Monitoraggio dettagliato delle performance mensili</p>
    </div>
    
    <div class="filter-section">
      <div class="section-header">
        <h3>Filtri e opzioni</h3>
      </div>
      <div class="filter-content">
        <div class="date-filter-row">
          <div class="date-selector-container">
            <span class="label">Filtra per Mese:</span>
            <div class="date-controls">
              <Button icon="pi pi-angle-double-left" class="p-button-rounded p-button-text nav-button" @click="onChange(-1)"/>
              <Calendar v-model="date" :maxDate="maxDate" :manualInput="false" view="month" dateFormat="mm/yy" class="calendar-custom" @update:modelValue="onChangeDate($event)"/>
              <Button v-if="moment(date).format('YYYY/MM') != max" icon="pi pi-angle-double-right" class="p-button-rounded p-button-text nav-button" @click="onChange(1)"/>
            </div>
          </div>
          <div class="action-buttons">
            <Button class="custom-button primary-button" @click="visibleEsitiPrecheck = true" v-tooltip.left="`Vedi esiti precheck switch out`">
              <i class="pi pi-file-excel button-icon"></i>
              <span class="button-text">Esiti Precheck</span>
            </Button>
            <Button class="custom-button secondary-button" @click="visibleFilePratiche = true" v-tooltip.left="`File precheck switch out`">
              <i class="pi pi-folder button-icon"></i>
              <span class="button-text">File Pratiche</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="report-section mb-3">
      <div class="section-header">
        <h3>Report Agenzie</h3>
      </div>
      <div class="report-content">
        <DataTable :value="report[filtro]" stripedRows showGridlines class="data-table-custom">
          <ColumnGroup type="header">
            <Row>
              <Column header="Agenzia" :rowspan="2" field="nome" style="width: 15%"/>
              <Column header="PP" :rowspan="2" field="count_total_pp" style="width: 5%"/>
              <Column header="PP OUT" :rowspan="2" field="count_total_pp_out" style="width: 5%"/>
              <Column header="Δ" :rowspan="2" field="count_total_pp_out" style="width: 5%"/>
              <Column header="PODS" :colspan="5"/>
              <Column header="PDRS" :colspan="5"/>
              <Column header="Rid" :rowspan="2" style="width: 5%"/>
              <Column header="OTP" :rowspan="2" style="width: 5%"/>
            </Row>
            <Row>
              <Column header="totali" field="pods"/>
              <Column header="valida" field="pods_val"/>
              <Column header="precheck / ko / ok"/>
              <Column header="caricati / bloccati"/>
              <Column header="switch out"/>
              <Column header="totali" field="pdrs"/>
              <Column header="valida" field="pdrs_val"/>
              <Column header="precheck / ko / ok"/>
              <Column header="caricati / bloccati"/>
              <Column header="switch out"/>
            </Row>
          </ColumnGroup>
          <Column field="nome" header="Agenzia"></Column>
          <Column field="count_total_pp" header="PP"></Column>
          <Column field="count_total_pp_out" header="PP OUT"></Column>
          <Column header="Δ">
            <template #body={data}>
              <div :class="stockClass(data.count_total_pp - data.count_total_pp_out)">
                {{ data.count_total_pp - data.count_total_pp_out }}
              </div>
            </template>
          </Column>

          <Column field="pods" header="pod"></Column>
          <Column field="pods_val" header="valida"></Column>
          <Column header="precheck / ok / ko">
            <template #body={data}>
              {{ data.pods_pk }} / {{ data.pods_pk_ko }} / {{ data.pods_pk_ok }}
            </template>
          </Column>
          <Column header="caricato / bloccato">
            <template #body={data}>
              {{ data.pods_ok }} / {{ data.pods_ko }}
            </template>
          </Column>
          <Column field="pods_out" header="switch out"></Column>
          <Column field="pdrs" header="pdr"></Column>
          <Column field="pdrs_val" header="valida"></Column>
          <Column header="precheck / ok / ko">
            <template #body={data}>
              {{ data.pdrs_pk }} / {{ data.pdrs_pk_ko }} / {{ data.pdrs_pk_ok }}
            </template>
          </Column>

          <Column header="caricato / bloccato">
            <template #body={data}>
              {{ data.pdrs_ok }} / {{ data.pdrs_ko }}
            </template>
          </Column>
          <Column field="pdrs_out" header="switch out"></Column>
          <Column header="Rid">
            <template #body="{data}">
              {{ data.rid }} / {{data.count_total_pp}}
            </template>
          </Column>
          <Column header="OTP">
            <template #body="{data}">
              {{ data.otp }} / {{data.n_caricamenti}}
            </template>
          </Column>
          <ColumnGroup type="footer">
            <Row>
              <Column footer="AGF ENERGY"/>
              <Column :footer="total_pp" />
              <Column :footer="total_pp_out" />
              <Column footer="">
                <template #footer>
                  <div :class="stockClass(delta)">
                    {{ delta }}
                  </div>
                </template>
              </Column>
              <Column :footer="pods"></Column>
              <Column :footer="pods_val"></Column>
              <Column :footer="`${pods_pk} / ${pods_pk_ko} / ${pods_pk_ok}`"></Column>
              <Column :footer="`${pods_ok} / ${pods_ko}`"></Column>
              <Column>
                <template #footer>
                  <Button class="custom-button download-button" v-tooltip="`Scarica file precheck switch out`" @click="downloadPrecheckFile('ee')">
                    <i class="pi pi-download button-icon"></i>
                    <span>{{ pods_out }}</span>
                  </Button>
                </template>
              </Column>
              <Column :footer="pdrs"></Column>
              <Column :footer="pdrs_val"></Column>
              <Column :footer="`${pdrs_pk} / ${pdrs_pk_ko} / ${pdrs_pk_ok}`"></Column>
              <Column :footer="`${pdrs_ok} / ${pdrs_ko}`"></Column>
              <Column :footer="pdrs_out"></Column>
              <Column>
                <template #footer>
                  <div class="summary-data">
                    {{`${rid} / ${total_pp}`}}
                    <small class="percentage">
                      {{ rid != 0 || total_pp != 0 ? Number((rid/total_pp)*100).toFixed(2) : '0.00' }} %
                    </small>
                  </div>
                </template>
              </Column>
              <Column>
                <template #footer>
                  <div class="summary-data">
                    {{`${otp} / ${n_caricamenti}`}}
                    <small class="percentage">
                      {{ otp != 0 || n_caricamenti != 0 ? Number((otp/n_caricamenti)*100).toFixed(2) : '0.00' }} %
                    </small>
                  </div>
                </template>
              </Column>
            </Row>
          </ColumnGroup>
        </DataTable>
      </div>
    </div>
    
    <div class="uploads-section mb-3">
      <div class="section-header">
        <h3>Report Caricamenti</h3>
      </div>
      <div class="uploads-content">
        <Accordion :multiple="true" :activeIndex="activeIndex[filtro]" @tab-open="getDataItem" class="accordion-custom">
          <AccordionTab v-for="settimana in items[filtro]" :key="settimana.title" :header="settimana.title">
            <div v-if="settimana.loaded">
              <DataTable :value="settimana.content" stripedRows tableStyle="min-width: 50rem" sortField="id" :sortOrder="-1" class="data-table-custom">
                <Column field="id" header="#"></Column>
                <Column field="intestazione" header="Nome Cliente">
                  <template #body="{data}">
                    <strong>{{ data.intestazione }}</strong>
                  </template>
                </Column>
                <Column field="pods" header="N. PODS"></Column>
                <Column field="pdrs" header="N. PDRS"></Column>
                <Column field="count_total_pp" header="Totale PP"></Column>
                <Column field="rid" header="Percentuale Rid">
                  <template #body="{data}">
                    {{ ((data.rid/data.count_total_pp)*100).toFixed(2) }} %
                  </template>
                </Column>
                <Column field="agenzia" header="Agenzia"></Column>
                <Column field="cartaceo" header="Tipologia contratto">
                  <template #body="{data}">
                    <strong>
                      {{ data.cartaceo ? 'CARTACEO' : 'OTP' }}
                    </strong>
                  </template>
                </Column>
              </DataTable>
            </div>
            <div v-else class="loading-spinner">
              <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  </div>
  
  <Dialog v-model:visible="visibleFilePratiche" modal :style="{ width: '80%', maxWidth: '1200px' }" maximizable class="modern-dialog">
    <template #header>
      <div class="dialog-header">
        <span class="dialog-title">File Pratiche</span>
      </div>
    </template>
    <FilePratiche />
  </Dialog>
  
  <Dialog v-model:visible="visibleEsitiPrecheck" modal :style="{ width: '80%', maxWidth: '1200px' }" maximizable class="modern-dialog">
    <template #header>
      <div class="dialog-header">
        <span class="dialog-title">Esiti Precheck Switch Out</span>
      </div>
    </template>
    <EsitiPrecheckSWO :data_search="date" />
  </Dialog>
</template>

<script>
import {ref, onMounted, computed, getCurrentInstance } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useRouter } from 'vue-router'
import { useToast } from "primevue/usetoast";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Calendar from 'primevue/calendar';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import moment from 'moment'
import FilePratiche from "./FilePratiche.vue";
import EsitiPrecheckSWO from "./EsitiPrecheckSWO.vue";
   
export default {
  components: {
    Loader,
    Calendar,
    FilePratiche,
    EsitiPrecheckSWO,
  },
  
  setup (props, {emit}) { 
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus

    const loading = ref(false)
    const date = ref(new Date())
    const maxDate = ref(date.value);
    const report = ref({})
    const items = ref({})
    const service = new Service(self.$eventBus)
    const activeIndex = ref({})
    const total_month = ref({})
    const currentYear = ref()
    const currentMonth = ref()
    const filtro = ref()
    const max = ref(moment(new Date()).format('YYYY/MM'))
    const visibleFilePratiche = ref(false)
    const visibleEsitiPrecheck = ref(false)

    onMounted(() => { 
      getData()
    })

    const onChangeDate = (evt) => {
      getData()
    }

    const onChange = (increment) => {
      date.value = new Date(moment(date.value).add(increment, 'months'))
      getData()
    }

    const getData = async () => {
      let fd = new FormData();

      let mese = date.value.getMonth()+1
      currentMonth.value = mese.toString().padStart(2,'0')
      currentYear.value = date.value.getFullYear() 
      filtro.value = `${currentYear.value}-${currentMonth.value}`
      if (report.value[filtro.value] == undefined || `${currentYear.value}/${currentMonth.value}` == max.value) {
        items.value[filtro.value] = []
        loading.value = true
        fd.append('filtro', filtro.value);
  
        await service.getReportCaricamenti(fd)
        .then((res)=>{
          items.value[filtro.value] = res.items
          activeIndex.value[filtro.value] = []
          setTotaliMese(filtro.value)
          let pods = 0
          let pods_val = 0
          let pods_pk = 0
          let pods_pk_ko = 0
          let pods_pk_ok = 0
          let pods_ok = 0
          let pods_ko = 0
          let pods_out = 0
  
          let pdrs = 0
          let pdrs_val = 0
          let pdrs_pk = 0
          let pdrs_pk_ko = 0
          let pdrs_pk_ok = 0
          let pdrs_ok = 0
          let pdrs_ko = 0
          let pdrs_out = 0
  
          let rid = 0
          let caricati = 0
          let n_caricamenti = 0
          let otp = 0
  
          res.report.forEach((agenzia)=>{
            pods += agenzia.pods
            pods_val += agenzia.pods_val
            pods_pk += agenzia.pods_pk
            pods_pk_ko += agenzia.pods_pk_ko
            pods_pk_ok += agenzia.pods_pk_ok
            pods_ok += agenzia.pods_ok
            pods_ko += agenzia.pods_ko
            pods_out += agenzia.pods_out
  
            pdrs += agenzia.pdrs
            pdrs_val += agenzia.pdrs_val
            pdrs_pk += agenzia.pdrs_pk
            pdrs_pk_ko += agenzia.pdrs_pk_ko
            pdrs_pk_ok += agenzia.pdrs_pk_ok
            pdrs_ok += agenzia.pdrs_ok
            pdrs_ko += agenzia.pdrs_ko
            pdrs_out += agenzia.pdrs_out
  
            rid += agenzia.rid
            caricati += agenzia.caricati
            n_caricamenti += agenzia.n_caricamenti
            otp += agenzia.otp
          })
          report.value[filtro.value] = res.report
  
          let total_pp = pods + pdrs
          let total_pp_out = pods_out + pdrs_out
          total_month.value[filtro.value][0]['total_pp'] = total_pp
          total_month.value[filtro.value][0]['total_pp_out'] = total_pp_out

          total_month.value[filtro.value][0]['pods'] = pods
          total_month.value[filtro.value][0]['pods_val'] = pods_val
          total_month.value[filtro.value][0]['pods_pk'] = pods_pk
          total_month.value[filtro.value][0]['pods_pk_ko'] = pods_pk_ko
          total_month.value[filtro.value][0]['pods_pk_ok'] = pods_pk_ok
          total_month.value[filtro.value][0]['pods_ok'] = pods_ok
          total_month.value[filtro.value][0]['pods_ko'] = pods_ko
          total_month.value[filtro.value][0]['pods_out'] = pods_out

          total_month.value[filtro.value][0]['pdrs'] = pdrs
          total_month.value[filtro.value][0]['pdrs_val'] = pdrs_val
          total_month.value[filtro.value][0]['pdrs_pk'] = pdrs_pk
          total_month.value[filtro.value][0]['pdrs_pk_ko'] = pdrs_pk_ko
          total_month.value[filtro.value][0]['pdrs_pk_ok'] = pdrs_pk_ok
          total_month.value[filtro.value][0]['pdrs_ok'] = pdrs_ok
          total_month.value[filtro.value][0]['pdrs_ko'] = pdrs_ko
          total_month.value[filtro.value][0]['pdrs_out'] = pdrs_out

          total_month.value[filtro.value][0]['rid'] = rid
          total_month.value[filtro.value][0]['caricati'] = caricati
          total_month.value[filtro.value][0]['n_caricamenti'] = n_caricamenti
          total_month.value[filtro.value][0]['otp'] = otp
        }).finally(()=>{
          loading.value = false
        })
      }
    }
    const total_pp = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['total_pp'] : 0;
    });
    const total_pp_out = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['total_pp_out'] : 0;
    })
    const pods = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods'] : 0;
    });
    const pods_val = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_val'] : 0;
    });

    const pods_pk = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_pk'] : 0;
    });
    const pods_pk_ko = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_pk_ko'] : 0;
    });
    const pods_pk_ok = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_pk_ok'] : 0;
    });
    const pods_ok = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_ok'] : 0;
    });
    const pods_ko = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_ko'] : 0;
    });
    const pods_out = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pods_out'] : 0;
    });
    const pdrs = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs'] : 0;
    });
    const pdrs_val = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_val'] : 0;
    });

    const pdrs_pk = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_pk'] : 0;
    });
    const pdrs_pk_ko = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_pk_ko'] : 0;
    });
    const pdrs_pk_ok = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_pk_ok'] : 0;
    });
    const pdrs_ok = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_ok'] : 0;
    });
    const pdrs_ko = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_ko'] : 0;
    });
    const pdrs_out = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['pdrs_out'] : 0;
    });
    const rid = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['rid'] : 0;
    });
    const otp = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['otp'] : 0;
    });
    const n_caricamenti = computed(() => {
      return filtro.value && filtro.value in report.value ? total_month.value[filtro.value][0]['n_caricamenti'] : 0;
    });
    const delta = computed(()=>{
      return total_pp.value - total_pp_out.value
    })

    const getDataItem = async (evt) => {
      let fd = new FormData();
      let {index} = evt

      if (!items.value[filtro.value][index].loaded) {
        let range = []
        let settimana = [...items.value[filtro.value][index].title.split('-')]
        settimana.forEach(giorno => {
          range.push(`${filtro.value}-${giorno}`)
        })
        fd.append('range', JSON.stringify(range));
        await service.getReportSettimana(fd)
        .then((res)=>{
          items.value[filtro.value][index].content = res.items
          items.value[filtro.value][index].loaded = true
        })
      }
    }
    const setTotaliMese = (prop) => {
      total_month.value[prop] = [{
        pods:0,
        pods_val:0,
        pods_pk:0,
        pods_pk_ko:0,
        pods_pk_ok:0,
        pods_ok:0,
        pods_ko:0,
        pods_out:0,

        pdrs:0,
        pdrs_val:0,
        pdrs_pk:0,
        pdrs_pk_ko:0,
        pdrs_pk_ok:0,
        pdrs_ok:0,
        pdrs_ko:0,
        pdrs_out:0,

        rid:0,
        caricati:0,
        n_caricamenti:0,
        otp:0
      }]
    }
    const stockClass = (data) => {
      return [
      'border-circle w-3rem h-3rem inline-flex font-bold justify-content-center align-items-center text-sm',
      {
        'bg-red-100': data < 1,
        'bg-green-100': data > 1
      }
      ];
    };

    const downloadPrecheckFile = async (type) => {
      loading.value = true
      let data_swout = moment(date.value).format('Y-MM-DD')
      await service.downloadPrecheckFileSwout(type, data_swout)
      .finally(()=>{
        loading.value = false
      })
    }

    return {
      moment,
      loading,
      items,
      report,
      currentMonth,
      currentYear,
      filtro,
      date,
      maxDate,
      onChangeDate,
      activeIndex,
      getDataItem,
      onChange,
      max,
      total_pp,
      pods,
      pods_val,
      pods_pk,
      pods_pk_ko,
      pods_pk_ok,
      pods_ok,
      pods_ko,
      pods_out,
      pdrs,
      pdrs_val,
      pdrs_pk,
      pdrs_pk_ko,
      pdrs_pk_ok,
      pdrs_ok,
      pdrs_ko,
      pdrs_out,
      rid,
      n_caricamenti,
      otp,
      total_pp_out,
      delta,
      stockClass,
      downloadPrecheckFile,
      visibleFilePratiche,
      visibleEsitiPrecheck
    }
  },
}
</script>

<style>
.bg-red-100 {
  background-color: rgba(255, 0, 0, 0.8);
  color: antiquewhite;
}

.bg-green-100 {
  background-color: rgba(0, 128, 0, 0.8);
  color: white;
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.credit-invoice {
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1.5rem;
}

.header-section {
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.subtitle {
  color: #7f8c8d;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.filter-section,
.report-section,
.uploads-section {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.section-header {
  background-color: #f8f9fa;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #eaeaea;
}

.section-header h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #3498db;
  margin: 0;
}

.filter-content,
.report-content,
.uploads-content {
  padding: 1.5rem;
}

.date-filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.date-selector-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.label {
  font-weight: 600;
  color: #7f8c8d;
}

.date-controls {
  display: flex;
  align-items: center;
}

.action-buttons {
  display: flex;
  gap: 1rem;
}

.custom-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.25rem;
  border-radius: 10px;
  border: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.custom-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.custom-button:hover::before {
  transform: translateX(0);
}

.primary-button {
  background-color: #3498db;
  color: white;
  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.25);
}

.primary-button:hover {
  background-color: #2980b9;
  box-shadow: 0 6px 12px rgba(52, 152, 219, 0.3);
  transform: translateY(-1px);
}

.secondary-button {
  background-color: #7f8c8d;
  color: white;
  box-shadow: 0 4px 6px rgba(127, 140, 141, 0.25);
}

.secondary-button:hover {
  background-color: #6c7a7b;
  box-shadow: 0 6px 12px rgba(127, 140, 141, 0.3);
  transform: translateY(-1px);
}

.download-button {
  background-color:#e74c3c;
  color: white !important;
  padding: 0.5rem 1rem;
  box-shadow: 0 4px 6px rgba(231, 76, 60, 0.25);
}

.download-button:hover {
  background-color: #c0392b !important;
  box-shadow: 0 6px 12px rgba(231, 76, 60, 0.3);
  transform: translateY(-1px);
}

.button-icon {
  margin-right: 0.75rem;
  font-size: 1.1rem;
}

.button-text {
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.nav-button {
  color: #3498db;
}

.calendar-custom {
  border-radius: 6px;
  overflow: hidden;
}

:deep(.p-calendar .p-inputtext) {
  border-color: #e0e0e0;
  border-radius: 6px;
  height: 42px;
  padding-left: 1rem;
  font-weight: 500;
}

:deep(.p-calendar .p-inputtext:focus) {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.data-table-custom {
  margin-bottom: 1.5rem;
}

:deep(.p-datatable) {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}

:deep(.p-datatable-thead > tr > th) {
  background-color: #f8f9fa;
  color: #555;
  font-weight: 600;
  padding: 0.8rem 1rem;
  border-bottom: 2px solid #f0f0f0;
}

:deep(.p-datatable-tbody > tr > td) {
  padding: 0.8rem 1rem;
  border-bottom: 1px solid #f5f5f5;
}

:deep(.p-datatable-tbody > tr:hover) {
  background-color: #f5f7fa;
}

:deep(.p-datatable-footer) {
  background-color: #f5f7fa;
  font-weight: 600;
}

.accordion-custom {
  margin-top: 1rem;
}

:deep(.p-accordion) {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

:deep(.p-accordion-header) {
  background-color: #f8f9fa;
}

:deep(.p-accordion-header-link) {
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: #34495e;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  transition: background-color 0.2s;
}

:deep(.p-accordion-header-link:hover) {
  background-color: #eef2f7;
}

:deep(.p-accordion-tab-active .p-accordion-header-link) {
  border-left: 4px solid #3498db;
}

:deep(.p-accordion-content) {
  padding: 1.5rem;
  background-color: white;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.summary-data {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.percentage {
  color: #7f8c8d;
  margin-top: 0.3rem;
}

.download-button {
  color: #3498db;
  font-weight: 600;
}

.download-button:hover {
  background-color: rgba(52, 152, 219, 0.1);
}

/* Modern Dialogs */
.modern-dialog {
  --primary-color: #3498db;
  --bg-color: #ffffff;
  --text-color: #2c3e50;
}

:deep(.modern-dialog .p-dialog-mask) {
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.4);
}

:deep(.modern-dialog .p-dialog) {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border: none;
}

:deep(.modern-dialog .p-dialog-header) {
  background-color: var(--bg-color);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.25rem 1.5rem;
}

:deep(.modern-dialog .p-dialog-content) {
  padding: 0;
  border: none;
  background-color: var(--bg-color);
}

:deep(.modern-dialog .p-dialog-footer) {
  background-color: var(--bg-color);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1rem 1.5rem;
}

:deep(.modern-dialog .p-dialog-header-icons) {
  padding: 0.25rem;
}

:deep(.modern-dialog .p-dialog-header-icon) {
  color: var(--text-color);
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
}

:deep(.modern-dialog .p-dialog-header-icon:hover) {
  background-color: rgba(0, 0, 0, 0.05);
  transform: rotate(90deg);
}

:deep(.modern-dialog .p-dialog-header-maximize-icon) {
  font-size: 1rem;
}

:deep(.modern-dialog .p-dialog-header-close-icon) {
  font-size: 1rem;
}

.dialog-header {
  display: flex;
  align-items: center;
}

.dialog-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 1.4rem;
  color: var(--primary-color);
  letter-spacing: -0.02em;
}

@media (max-width: 768px) {
  .date-filter-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .date-selector-container {
    width: 100%;
    margin-bottom: 1rem;
  }
  
  .action-buttons {
    width: 100%;
    justify-content: space-between;
  }
  
  .calendar-custom {
    width: 100%;
  }
}
</style>